import { type PollsDataSource } from '../../data/polls.datasource'

export interface LinkablePost {
  id: number
  title: string
  hasPoll: boolean
}

export class GetLinkablePostsInteractor {
  constructor(private readonly dataSource: PollsDataSource) {}

  async execute(search?: string, limit = 50): Promise<LinkablePost[]> {
    const items = await this.dataSource.listForumPosts()
    const term = search?.trim().toLowerCase() ?? ''
    const filtered = term
      ? items.filter((p) => p.title.toLowerCase().includes(term) || String(p.id).includes(term))
      : items
    return filtered.slice(0, limit)
  }
}
